import React from "react";
import AddOnPurchasePriceWidget from "../../activity/add-on-purchase/AddOnPurchasePriceWidget";
import type { AddOnPurchasePriceProps } from "../../activity/add-on-purchase/AddOnPurchasePriceWidget";

// 顺手买移动价格入口复用其专属价格语义；普通移动价格组件保持原样。
const MAddOnPurchasePriceWidget: React.FC<AddOnPurchasePriceProps> = (props) => (
  <AddOnPurchasePriceWidget {...props} />
);
export default MAddOnPurchasePriceWidget;
